<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px" label-width="80px">
      <el-form-item label="名称">
        <el-input v-model="queryParams.name" class="!w-200px" clearable @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" class="!w-160px" clearable>
          <el-option label="草稿" :value="0" />
          <el-option label="待审" :value="1" />
          <el-option label="已通过" :value="2" />
          <el-option label="已驳回" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button
          v-hasPermi="['product:pool-draft:create']"
          type="primary"
          @click="openUpload()"
        >
          代供上传新品
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="编号" prop="id" width="80" />
      <el-table-column label="供应商" prop="supplierName" min-width="120" />
      <el-table-column label="商品名称" prop="name" min-width="160" />
      <el-table-column label="状态" width="90">
        <template #default="{ row }">{{ statusLabel(row.status) }}</template>
      </el-table-column>
      <el-table-column label="首挂SPU" prop="spuId" width="100" />
      <el-table-column label="操作" width="320">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row)">详情</el-button>
          <el-button
            v-if="row.status !== 2"
            v-hasPermi="['product:pool-draft:create']"
            link
            type="primary"
            @click="openUpload(row.id)"
          >
            编辑
          </el-button>
          <el-button
            v-if="row.status === 1"
            v-hasPermi="['product:pool-draft:audit']"
            link
            type="success"
            @click="openApprove(row)"
          >
            通过
          </el-button>
          <el-button
            v-if="row.status === 1"
            v-hasPermi="['product:pool-draft:audit']"
            link
            type="danger"
            @click="openReject(row)"
          >
            驳回
          </el-button>
          <el-button
            v-if="row.status === 2"
            v-hasPermi="['product:pool-draft:audit']"
            link
            type="primary"
            @click="openPick(row)"
          >
            选品挂店
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="货品池详情" width="640px">
    <el-descriptions v-if="current" :column="1" border>
      <el-descriptions-item label="供应商">{{ current.supplierName }}</el-descriptions-item>
      <el-descriptions-item label="名称">{{ current.name }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabel(current.status) }}</el-descriptions-item>
      <el-descriptions-item label="简介">{{ current.introduction }}</el-descriptions-item>
      <el-descriptions-item label="封面">
        <el-image v-if="current.picUrl" :src="current.picUrl" class="!w-80px !h-80px" />
      </el-descriptions-item>
      <el-descriptions-item label="驳回原因">{{ current.auditRemark || '-' }}</el-descriptions-item>
      <el-descriptions-item label="首挂SPU">{{ current.spuId || '-' }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>

  <Dialog v-model="approveVisible" title="审核通过" width="480px">
    <div class="text-14px mb-8px">确认内容过审？通过后进入可选品库，不会立刻生成商品。</div>
    <div class="text-12px text-gray-500">请使用「选品挂店」选择店铺与运费模板后再生成下架商品。</div>
    <template #footer>
      <el-button @click="approveVisible = false">取消</el-button>
      <el-button type="primary" :loading="auditLoading" @click="doApprove">确定通过</el-button>
    </template>
  </Dialog>

  <Dialog v-model="pickVisible" title="选品挂店" width="520px">
    <el-form label-width="120px">
      <el-form-item label="挂靠店铺" required>
        <el-select
          v-model="pickShopId"
          filterable
          class="!w-full"
          placeholder="请选择自营店铺"
          @change="loadTemplates"
        >
          <el-option v-for="s in shops" :key="s.id" :label="s.name" :value="s.id" />
        </el-select>
        <div v-if="shops.length === 0" class="text-12px text-[var(--el-color-warning)] mt-4px">
          暂无自营店。请刷新或确认有「新增自营店铺」权限；系统会在自营模式下尝试自动创建。
        </div>
        <div v-else-if="shops.length === 1" class="text-12px text-gray-500 mt-4px">
          已自动选中唯一自营店
        </div>
      </el-form-item>
      <el-form-item
        v-if="needExpress"
        label="运费模板"
        required
      >
        <el-select v-model="pickTemplateId" filterable class="!w-full" placeholder="请选择本店运费模板">
          <el-option v-for="t in templates" :key="t.id" :label="t.name" :value="t.id!" />
        </el-select>
        <div v-if="pickShopId && templates.length === 0" class="text-12px text-[var(--el-color-warning)] mt-4px">
          该自营店暂无运费模板。请到「配送管理 → 运费模板」新建，并绑定本店 shopId 后再挂店。
        </div>
      </el-form-item>
      <div class="text-12px text-gray-500">挂店后生成下架商品，请到商品列表再上架。</div>
    </el-form>
    <template #footer>
      <el-button @click="pickVisible = false">取消</el-button>
      <el-button type="primary" :loading="auditLoading" @click="doPick">确定挂店</el-button>
    </template>
  </Dialog>

  <Dialog v-model="rejectVisible" title="审核驳回" width="480px">
    <el-input v-model="rejectRemark" type="textarea" :rows="3" placeholder="请填写驳回原因" />
    <template #footer>
      <el-button @click="rejectVisible = false">取消</el-button>
      <el-button type="danger" :loading="auditLoading" @click="doReject">确定驳回</el-button>
    </template>
  </Dialog>

  <PoolDraftForm ref="uploadFormRef" @success="getList" />
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import {
  approvePoolDraft,
  getPoolDraftPage,
  pickPoolDraft,
  rejectPoolDraft,
  type PoolDraftVO
} from '@/api/mall/product/pool'
import { getShopSimpleList } from '@/api/merchant/shop-manager'
import {
  ensureDefaultSelfOperatedShops,
  MALL_SELF_OPERATED_SHOP_TYPE,
  pickDefaultSelfOperatedShopId
} from '@/utils/mallSelfOperatedShop'
import * as ExpressTemplateApi from '@/api/mall/trade/delivery/expressTemplate'
import PoolDraftForm from './PoolDraftForm.vue'
import { DeliveryTypeEnum } from '@/utils/constants'

defineOptions({ name: 'ProductPoolDraft' })

const loading = ref(false)
const auditLoading = ref(false)
const list = ref<PoolDraftVO[]>([])
const total = ref(0)
const queryParams = reactive<any>({ pageNo: 1, pageSize: 10, name: undefined, status: 1 })
const statusLabel = (s?: number) =>
  ({ 0: '草稿', 1: '待审', 2: '已通过', 3: '已驳回' } as any)[s ?? -1] || '-'

const detailVisible = ref(false)
const current = ref<PoolDraftVO>()
const approveVisible = ref(false)
const pickVisible = ref(false)
const rejectVisible = ref(false)
const pickShopId = ref<number>()
const pickTemplateId = ref<number>()
const rejectRemark = ref('')
const shops = ref<{ id: number; name: string; shopType?: number }[]>([])
const templates = ref<ExpressTemplateApi.DeliveryExpressTemplateVO[]>([])
const uploadFormRef = ref()

const needExpress = computed(() =>
  (current.value?.deliveryTypes || []).includes(DeliveryTypeEnum.EXPRESS.type)
)

const getList = async () => {
  loading.value = true
  try {
    const data = await getPoolDraftPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryParams.name = undefined
  queryParams.status = 1
  handleQuery()
}

const openUpload = (id?: number) => {
  uploadFormRef.value?.open(id, false)
}

const openDetail = (row: PoolDraftVO) => {
  current.value = row
  detailVisible.value = true
}

const openApprove = (row: PoolDraftVO) => {
  current.value = row
  approveVisible.value = true
}

const openPick = async (row: PoolDraftVO) => {
  current.value = row
  pickShopId.value = undefined
  pickTemplateId.value = undefined
  templates.value = []
  // 仅自营店可挂（A 端 createSpu 强制 shop_type=1）；无店则自动建默认店
  shops.value = (await ensureDefaultSelfOperatedShops()) || []
  if (!shops.value.length) {
    const fallback = (await getShopSimpleList({ shopType: MALL_SELF_OPERATED_SHOP_TYPE })) || []
    shops.value = fallback.map((s: any) => ({
      id: Number(s.id),
      name: s.name || `店铺${s.id}`,
      shopType: s.shopType ?? MALL_SELF_OPERATED_SHOP_TYPE
    }))
  }
  const def = pickDefaultSelfOperatedShopId(shops.value)
  if (def) {
    pickShopId.value = def
    await loadTemplates()
  }
  pickVisible.value = true
}

const loadTemplates = async () => {
  pickTemplateId.value = undefined
  if (!pickShopId.value) {
    templates.value = []
    return
  }
  const all = (await ExpressTemplateApi.getSimpleTemplateList()) || []
  // 本店模板优先；历史无 shopId 的模板兼容可选（新建须绑店）
  templates.value = all.filter((t: any) => {
    const sid = t.shopId
    return sid == null || sid === 0 || sid === pickShopId.value
  })
}

const openReject = (row: PoolDraftVO) => {
  current.value = row
  rejectRemark.value = ''
  rejectVisible.value = true
}

const doApprove = async () => {
  if (!current.value?.id) return
  auditLoading.value = true
  try {
    await approvePoolDraft({ id: current.value.id })
    ElMessage.success('已过审，可在列表中选品挂店')
    approveVisible.value = false
    getList()
  } finally {
    auditLoading.value = false
  }
}

const doPick = async () => {
  if (!current.value?.id || !pickShopId.value) {
    ElMessage.warning('请选择店铺')
    return
  }
  if (needExpress.value && !pickTemplateId.value) {
    ElMessage.warning('请选择运费模板')
    return
  }
  auditLoading.value = true
  try {
    await pickPoolDraft({
      id: current.value.id,
      shopId: pickShopId.value,
      deliveryTemplateId: pickTemplateId.value
    })
    ElMessage.success('已挂店生成下架商品，请到商品列表上架')
    pickVisible.value = false
    getList()
  } finally {
    auditLoading.value = false
  }
}

const doReject = async () => {
  if (!current.value?.id || !rejectRemark.value.trim()) {
    ElMessage.warning('请填写驳回原因')
    return
  }
  auditLoading.value = true
  try {
    await rejectPoolDraft({ id: current.value.id, auditRemark: rejectRemark.value.trim() })
    ElMessage.success('已驳回')
    rejectVisible.value = false
    getList()
  } finally {
    auditLoading.value = false
  }
}

onMounted(getList)
</script>
